
export default class ParametroConsultaEliminadas{

    constructor(){
        this.FechaEliminacionDesde= "";
        this.FechaEliminacionHasta = "";
        this.UsuarioElimino = "";
    }

    FechaEliminacionDesde:string;
    FechaEliminacionHasta:string;
    UsuarioElimino:string;
}